import { Media, MediaPickerComponent, Product } from '@gripp/shared-logic';
import { HeaderCoverImage } from '@gripp/shared-ui';

type ProductDetailImageProps = {
  productCoverImage?: Media;
  imgSize?: number;
  maxRetries?: number;
  retryDelay?: number;
  invalidateQuery?: () => void;
  product?: Product; // Add product prop to access media array
  newlyUploadedMedia?: Media | null; // Newly uploaded media to show immediately
  mediaPicker?: MediaPickerComponent; // Add media picker for image changing
  onImageChanged?: () => void;
};

export const ProductDetailImage = (props: ProductDetailImageProps) => {
  // Use newly uploaded media first, then coverImage, then first media item
  const coverImage = props.productCoverImage || props.product?.coverImage || props.product?.media?.[0];
  
  return (
    <HeaderCoverImage
      key={coverImage?.id || 'no-image'} // Force re-render when media changes
      media={coverImage}
      imgSize={props.imgSize}
      maxRetries={props.maxRetries}
      retryDelay={props.retryDelay}      
      invalidateQuery={props.invalidateQuery}
      iconName="qrcode"
      product={props.product}
      mediaPicker={props.mediaPicker}
      onImageChanged={props.onImageChanged}
    />
  );
};
